import { apiQueryAdapter } from "../apiQueryAdapter";
import { PageResponseModel } from "../common/models";
import {
  LoadBoardChangeLogEntry,
  LoadBoardChangeLogFilterParams,
} from "./loadBoardChangeLogModels";

const PAGE_SIZE = 50;

class LoadBoardChangeLogService {
  private static instance: LoadBoardChangeLogService;

  static getInstance(): LoadBoardChangeLogService {
    if (!LoadBoardChangeLogService.instance) {
      LoadBoardChangeLogService.instance = new LoadBoardChangeLogService();
    }
    return LoadBoardChangeLogService.instance;
  }

  /**
   * Search Load Board change audit log.
   * GET /load-board/change-log
   */
  public search = async (
    filter: LoadBoardChangeLogFilterParams = {},
    page = 0
  ): Promise<PageResponseModel<LoadBoardChangeLogEntry>> => {
    const params: Record<string, string | number> = {
      page,
      size: filter.size ?? PAGE_SIZE,
    };
    if (filter.manifestNumber != null) params.manifestNumber = filter.manifestNumber;
    if (filter.terminalNumber != null) params.terminalNumber = filter.terminalNumber;
    if (filter.actionType) params.actionType = filter.actionType;
    if (filter.dateFrom) params.dateFrom = filter.dateFrom;
    if (filter.dateTo) params.dateTo = filter.dateTo;
    if (filter.search) params.search = filter.search;

    const response = await apiQueryAdapter.query<
      PageResponseModel<LoadBoardChangeLogEntry>
    >("/load-board/change-log", "GET", { params });

    return response.data;
  };
}

export default LoadBoardChangeLogService.getInstance();
